import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Activate } from './routes/Activate.js';
import { CustomerLogin } from './routes/CustomerLogin.js';
import { Login } from './routes/Login.js';
import { AdminAccount } from './routes/admin/Account.js';
import { CustomerDetail } from './routes/admin/CustomerDetail.js';
import { Customers } from './routes/admin/Customers.js';
import { AdminInquiries } from './routes/admin/Inquiries.js';
import { AdminInquiryDetail } from './routes/admin/InquiryDetail.js';
import { AdminLayout } from './routes/admin/Layout.js';
import { Licenses } from './routes/admin/Licenses.js';
import { Users } from './routes/admin/Users.js';
import { CustomerAccount } from './routes/customer/Account.js';
import { CustomerDashboard } from './routes/customer/Dashboard.js';
import { CustomerInquiries } from './routes/customer/Inquiries.js';
import { CustomerInquiryDetail } from './routes/customer/InquiryDetail.js';
import { CustomerLayout } from './routes/customer/Layout.js';
import { CustomerLicenses } from './routes/customer/Licenses.js';
import { NewInquiry } from './routes/customer/NewInquiry.js';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/activate" replace />} />
        <Route path="/activate" element={<Activate />} />
        <Route path="/login" element={<Login />} />
        <Route path="/customer/login" element={<CustomerLogin />} />

        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="licenses" replace />} />
          <Route path="licenses" element={<Licenses />} />
          <Route path="customers" element={<Customers />} />
          <Route path="customers/:id" element={<CustomerDetail />} />
          <Route path="users" element={<Users />} />
          <Route path="inquiries" element={<AdminInquiries />} />
          <Route path="inquiries/:id" element={<AdminInquiryDetail />} />
          <Route path="account" element={<AdminAccount />} />
        </Route>

        <Route path="/customer" element={<CustomerLayout />}>
          <Route index element={<CustomerDashboard />} />
          <Route path="licenses" element={<CustomerLicenses />} />
          <Route path="inquiries" element={<CustomerInquiries />} />
          <Route path="inquiries/new" element={<NewInquiry />} />
          <Route path="inquiries/:id" element={<CustomerInquiryDetail />} />
          <Route path="account" element={<CustomerAccount />} />
        </Route>

        <Route path="*" element={<Navigate to="/activate" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
